<script lang="ts">
export default { name: 'CommonIcon' }
</script>

<script setup lang="ts">
interface Props {
  name: string
}
defineProps<Props>()
</script>

<template>
  <i class="inline-block" :class="`icon-${name} w-[1em] flex place-content-center`"></i>
</template>

<style src="@/assets/icons/style.css"></style>
